import { j as i } from "./jsx-runtime-944c88e2.js";
import { Icon as t } from "@chakra-ui/icons";
const f = (c) => {
  var l;
  return /* @__PURE__ */ i.jsx(t, { xmlns: "http://www.w3.org/2000/svg", width: "24px", height: "24px", fill: "none", ...c, children: /* @__PURE__ */ i.jsx(
    "path",
    {
      fill: ((l = c == null ? void 0 : c.fill) == null ? void 0 : l.toString()) ?? "#fff",
      fillRule: "evenodd",
      d: "M19.23 19.614A10.47 10.47 0 0 0 22.5 12c0-5.799-4.701-10.5-10.5-10.5S1.5 6.201 1.5 12c0 2.81 1.104 5.363 2.903 7.248 1.63-2.391 4.28-3.967 7.294-3.967 3.167 0 5.93 1.738 7.533 4.333Zm-1.172.963c-1.34-2.298-3.7-3.796-6.36-3.796-2.54 0-4.805 1.365-6.172 3.486A10.455 10.455 0 0 0 12 22.5c2.256 0 4.347-.712 6.058-1.923Zm-13.666.704A11.95 11.95 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12c0 3.445 1.452 6.552 3.778 8.74a.748.748 0 0 0 .614.54Zm9.523-8.906c.603-.694 1.06-1.814 1.06-3.424 0-2.166-1.584-3.7-3.278-3.7s-3.279 1.534-3.279 3.7c0 3 1.644 4.478 3.126 4.478.966 0 1.78-.372 2.371-1.054Zm-2.371 2.554c2.768 0 4.932-2.195 4.932-5.978 0-2.872-2.14-5.2-4.78-5.2-2.638 0-4.778 2.328-4.778 5.2 0 3.456 1.986 5.978 4.626 5.978Z",
      clipRule: "evenodd"
    }
  ) });
};
export {
  f as P
};
